import TitlePage from "@components/atoms/TitlePage/TitlePage";
import GenericTable from "../GenericTable/GenericTable";
import { IProductsUI } from "src/types/organisms";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
const ProductsUI = ({
  isLoading,
  showError,
  closeError,
  errorMessage,
  headers,
  rows,
  onClick,
  pages,
  currentPage,
  onChangePage,
  onSearch,
  onSearchClick
}: IProductsUI) => {
  return <>
      <TitlePage title="Productos" subtitle="Gestión de productos, añade, consulta y edita precios de productos." />
      <GenericTable isLoading={isLoading} title="Lista de productos" buttonLabel="Crear producto" onClick={onClick} headers={headers} rows={rows} pages={pages} currentPage={currentPage} onChangePage={onChangePage} emptyMessage="Sin productos encontrados" searchLabel="Buscar producto" onSearch={onSearch} onSearchClick={onSearchClick} />
      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />
    </>;
};
export default ProductsUI;